import { MultiSelectOptions } from '@shared/ui'
import { POLICY_STATUS } from '@shared/data-access'

export const FORM_FILTER_NAME = Object.freeze({
  socialReferent: 'socialReferent',
  subscriptionAppointment: 'subscriptionAppointment',
  initialAnalysisAppointment: 'initialAnalysisAppointment',
  policyStates: 'policyStates',
})

export const scheduledOptions = (
  t: (trans: string) => string,
): MultiSelectOptions[] => [
  { label: t('common:scheduled'), value: '1' },
  { label: t('common:noScheduled'), value: '0' },
]

export const policyStateOptions = (
  t: (trans: string) => string,
) => [
  {
    label: t('common:policyState.subscriptionPending'),
    value: POLICY_STATUS.subscriptionPending,
    defaultChecked: true,
  },
  {
    label: t('common:policyState.accepted'),
    value: POLICY_STATUS.accepted,
    defaultChecked: true,
  },
  {
    label: t('common:policyState.refused'),
    value: POLICY_STATUS.refused,
    defaultChecked: false,
  },
  {
    label: t('common:policyState.cancelled'),
    value: POLICY_STATUS.cancelled,
    defaultChecked: false,
  },
]
